import type { ReactElement, ReactNode } from 'react';
import { Navigate, useLocation } from 'react-router-dom';

import { useAuth } from '../auth/index.js';
import { hasCompletedOnboardingTags } from './onboarding-tags.js';

export interface ExperienceGuardProps {
  children: ReactNode;
}

export function ExperienceGuard({ children }: ExperienceGuardProps): ReactElement {
  const { user, isLoading } = useAuth();
  const location = useLocation();

  if (isLoading) {
    return <p style={{ color: 'var(--fm-color-text-muted)' }}>Loading…</p>;
  }

  if (user?.role === 'USER' && !user.experienceOnboardingCompleted) {
    return <Navigate to="/onboarding/experience" replace />;
  }

  if (
    user?.role === 'USER' &&
    user.experienceOnboardingCompleted &&
    !user.turnOnsCompleted &&
    !location.pathname.startsWith('/onboarding/')
  ) {
    return <Navigate to="/onboarding/turn-ons" replace />;
  }

  if (
    user?.role === 'USER' &&
    user.experienceOnboardingCompleted &&
    user.turnOnsCompleted &&
    !hasCompletedOnboardingTags() &&
    !location.pathname.startsWith('/onboarding/')
  ) {
    return <Navigate to="/onboarding/tags" replace />;
  }

  return <>{children}</>;
}
